(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["upupa-order-browser"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('upupa-order-browser')) {
    customElements.define('upupa-order-browser', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.modes = [...this.querySelectorAll('[data-order-mode]')];
        this.panels = [...this.querySelectorAll('[data-order-panel]')];
        this.querySelector('nav').setAttribute('role', 'tablist');
        this.modes.forEach(mode => {
          mode.setAttribute('role', 'tab');
          mode.setAttribute('aria-controls', `upupa-mode-${mode.dataset.orderMode}-panel`);
        });
        this.panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', `upupa-mode-${panel.dataset.orderPanel}`);
        });
        this.addEventListener('click', event => {
          const mode = event.target.closest('[data-order-mode]');
          if (!mode || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.select(mode.dataset.orderMode, true);
        });
        this.addEventListener('keydown', event => {
          const mode = event.target.closest('[data-order-mode]');
          if (!mode || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? this.modes[0] : event.key === 'End' ? this.modes[1] : this.modes.find(item => item !== mode);
          this.select(next.dataset.orderMode, true);
          next.focus();
        });
        this.hashHandler = () => this.select(this.modeFromLocation());
        window.addEventListener('hashchange', this.hashHandler);
        this.select(this.modeFromLocation());
      }
      disconnectedCallback() {
        window.removeEventListener('hashchange', this.hashHandler);
        this.ready = false;
      }
      modeFromLocation() {
        return location.hash === '#viikon-menu' || (!location.hash && new URLSearchParams(location.search).has('pvm')) ? 'day' : 'food';
      }
      select(value, updateUrl = false) {
        this.modes.forEach(mode => {
          const selected = mode.dataset.orderMode === value;
          mode.setAttribute('aria-selected', String(selected));
          mode.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.orderPanel !== value; });
        if (updateUrl) {
          history.replaceState(history.state, '', value === 'food' ? '#ruoat' : '#viikon-menu');
          if (value === 'day') {
            const calendar = this.querySelector('[data-date-switch]');
            if (calendar) calendar.open = true;
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["upupa-product-reviews"] && !Shopify.designMode) return;
  try {
    const showReviewThanks = (root) => {
    const thanked = new URLSearchParams(window.location.search).get('arvio') === 'kiitos';
    const reviews = root.querySelector('#arviot');
    if (!reviews) return;
    const message = reviews.querySelector('[data-review-thanks]');
    if (thanked && message) message.hidden = false;
    if (thanked || window.location.hash === '#arviot' || reviews.querySelector('[data-review-server-error]')) {
      const disclosure = reviews.closest('details');
      if (disclosure) disclosure.open = true;
    }
  };
  showReviewThanks(document);
  document.addEventListener('shopify:section:load', (event) => showReviewThanks(event.target));
  window.addEventListener('hashchange', () => showReviewThanks(document));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["upupa-review-fields"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const form = event.target.closest('.upupa-rv-form');
    if (!form) return;
    if (event.target.name === 'upupa_rating') {
      form.querySelector('.upupa-rv-stars').dataset.rating = event.target.value || '0';
    }

  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.upupa-rv-form')) return;
    const body = form.querySelector('[data-review-body]');
    const text = body.value.trim();
    const error = form.querySelector('#upupa-rv-error');
    if (!text) {
      event.preventDefault();
      error.hidden = false;
      body.focus();
      return;
    }
    error.hidden = true;
    const rating = form.querySelector('input[name="upupa_rating"]:checked');
    const encoded = form.querySelector('[data-review-encoded]');
    encoded.value = rating && rating.value ? '[' + rating.value + '] ' + text : text;
    encoded.disabled = false;
    body.removeAttribute('name');
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    const returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo && preview && /^\d+$/.test(preview)) {
      const target = new URL(returnTo.value, window.location.origin);
      target.searchParams.set('preview_theme_id', preview);
      returnTo.value = target.pathname + target.search + target.hash;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
